<div class="modal-header">
    <div class="d-flex align-items-center">
        <span class="circle-icon me-2" [ngClass]="isMaster ? 'bg-master' : 'bg-formulary'">{{isMaster ? 'M' :
            'F'}}</span>
        <div>
            <h5 class="modal-title">{{isMaster ? 'Master' : 'Formulary'}} Item List</h5>
            <ul class="list-unstyled m-0 d-flex" *ngIf="isMaster">
                <li class="me-3"><label class="text-medium">Name:</label> {{fileInfo.commonName}}</li>
            </ul>
        </div>
    </div>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<div class="modal-body" [ngSwitch]="showList">
    <div class="row align-items-end gx-2 mb-3">
        <div class="col-md mb-3 mb-md-0">
            <label class="form-label">Keywords</label>
            <input type="text" class="form-control form-control-lg" placeholder="Search Item Description and Number" (keydown)="inputFieldChange($event)" (ngModelChange)="hideTheList()" [(ngModel)]="filter.textFilter" />
        </div>
        <div class="col-md mb-3 mb-md-0" *ngIf="!isMaster">
            <label class="form-label d-block">Vendor Account Number</label>
            <input id="item-account-input" class="form-control form-control-lg" [(ngModel)]="filter.vendorAccountNumber" placeholder="Search Vendor Account Number" (keydown)="inputFieldChange($event)" (ngModelChange)="hideTheList()" />
        </div>
        <div class="col-md mb-3 mb-md-0" *ngIf="!isMaster">
            <label class="form-label d-block">PDx ID</label>
            <input id="item-parent-input" class="form-control form-control-lg" [(ngModel)]="filter.pdxId" placeholder="Search PDx ID" (keydown)="inputFieldChange($event)" (ngModelChange)="hideTheList()" />
        </div>
        <div class="col-xl mt-3 mt-xl-0">
            <div class="row gx-2 justify-content-xxl-end justify-content-center search-btns">
                <div class="col-auto">
                    <button type="button" class="btn btn-secondary btn-round btn-lg text-uppercase text-strong" (click)="showTheList()"><i class="far fa-search"></i> Search</button>
                </div>
                <div class="col-auto">
                    <button type="button" class="btn btn-white btn-round btn-lg text-uppercase text-strong" (click)="resetFilters()"><i class="far fa-times"></i> Clear</button>
                </div>
            </div>
        </div>
    </div>
    <div class="p-3 text-center" *ngSwitchCase="false">
        <h3>Search Items</h3>
        <p>Enter search parameters above to find items.</p>
        <div class="mx-auto">
            <button type="button" class="btn btn-round btn-outline-secondary text-uppercase text-strong" (click)="showTheList()">Show All</button>
        </div>
    </div>
    <table class="table table-striped table-hover align-middle m-0" *ngSwitchCase="true">
        <thead>
            <tr>
                <th class="nowrap">
                    <table-sorting [(col)]="filter.sortedColumn" [(dir)]="filter.sortedDirection" colName="Item Desc." [cb]="loadList"></table-sorting>
                </th>
                <th class="nowrap">
                    <table-sorting [(col)]="filter.sortedColumn" [(dir)]="filter.sortedDirection" colName="Item #" [cb]="loadList"></table-sorting>
                </th>
                <th class="nowrap" *ngIf="!isMaster">
                    <table-sorting [(col)]="filter.sortedColumn" [(dir)]="filter.sortedDirection" colName="PDx ID" [cb]="loadList"></table-sorting>
                </th>
                <th class="nowrap" *ngIf="!isMaster">
                    <table-sorting [(col)]="filter.sortedColumn" [(dir)]="filter.sortedDirection" colName="Vendor #" [cb]="loadList"></table-sorting>
                </th>
                <th class="nowrap">
                    <table-sorting [(col)]="filter.sortedColumn" [(dir)]="filter.sortedDirection" colName="Price" [cb]="loadList"></table-sorting>
                </th>
                <th class="nowrap">
                    <table-sorting [(col)]="filter.sortedColumn" [(dir)]="filter.sortedDirection" colName="Manufacturer" [cb]="loadList"></table-sorting>
                </th>
                <th class="nowrap">
                    <table-sorting [(col)]="filter.sortedColumn" [(dir)]="filter.sortedDirection" colName="Manufacturer Part #" [cb]="loadList"></table-sorting>
                </th>
                <th class="text-right"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of results.data">
                <td class="item-desc-col">
                    <p class="text-medium mb-1">{{item.itemDescription}}</p>
                    <ul class="d-flex align-items-center list-unstyled p-0 m-0" *ngIf="item.strength || item.size">
                        <li class="me-3" *ngIf="item.strength">Strength: {{item.strength}}</li>
                        <li class="me-3" *ngIf="item.size">Size: {{item.size}}</li>
                    </ul>
                </td>
                <td>{{item.vendorItemNumber}}</td>
                <td *ngIf="!isMaster">{{item.pdxId}}</td>
                <td *ngIf="!isMaster">{{item.vendorAccountNumber}}</td>
                <td>
                    {{item.baseUOMPrice | currency}}/{{item.uom}}
                    <span *ngIf="item.itemCaseQty > 1"><br />{{item.baseUOMPrice * item.itemCaseQty | currency}}/{{item.secondaryUOM}}</span>
                </td>
                <td>{{item.manufacturerName}}</td>
                <td>{{item.manufacturerPartNumber}}</td>
                <td class="text-right">
                    <ng-template #deletePopover>
                        <strong>Are you sure you want to delete this item?</strong> <a href="javascript:void(0)" (click)="deleteItem(item.itemId)" class='btn btn-primary btn-round w-100 mt-2'><i class='far fa-trash-alt'></i> Delete</a>
                    </ng-template>
                    <button type="button" [ngbPopover]="deletePopover" class="btn btn-lg btn-white btn-shadow action-btn text-danger"><i class="far fa-trash-alt"></i></button>
                </td>
            </tr>
            <tr *ngIf="results.data.length == 0">
                <td [attr.colspan]="6 + (isMaster ? 0 : 2)" class="text-center">No items found.</td>
            </tr>
        </tbody>
    </table>
    <div *ngSwitchCase="true" class="p-3 d-md-flex align-items-center justify-content-md-between justify-content-center text-center text-md-left">
        <p class="m-md-0 mb-3">{{filter.showing(results.recordsFiltered)}}</p>
        <ngb-pagination [(page)]="filter.page" [pageSize]="filter.pageSize" [collectionSize]="results.recordsFiltered" (pageChange)="loadList(false)" size="lg" [maxSize]="5" [rotate]="true" [ellipses]="false" [boundaryLinks]="true"></ngb-pagination>
    </div>
</div>